<template>
  <div>
    <v-flex v-if="ocult">
      {{text.slice(0,500)}}...
      <a @click="ocult = !ocult">read more</a>
    </v-flex>
    <v-flex v-else>
      {{text}}
      <a v-if="text.length > 500" @click="ocult = !ocult">read less</a>
    </v-flex>
  </div>
</template>
<script>
export default {
  props: ["text"],
  created() {
    this.ocult = this.text.length > 500;
  },
  data() {
    return {
      ocult: false
    };
  }
};
</script>
